export const AGENT_STATUS_POLL_INTERVAL_MS = 250;
export const EXTERNAL_TRANSPORT_LIVENESS_POLL_INTERVAL_MS = 2_000;
export const AGENT_STARTUP_MAX_ATTEMPTS = 3;
export const AGENT_STARTUP_RETRY_BASE_DELAY_MS = 500;
